module.exports = __webpack_public_path__ + "img/brandlogo.542ac122.jpg";